import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';

const SplitHeroMobileContainer = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.md}px) {
    display: none;
  }
`;

const SplitHeroDesktopContainer = styled.div`
  display: none;

  @media (min-width: ${breakpoints.md}px) {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const MobileOnlyContainer = styled.div`
  width: 100vw;
  height: 80vw;

  /* stylelint-disable-next-line selector-type-no-unknown */
  && progressive-img, img {
    width: 100vw;
    height: 80vw;
    --img-width: 100vw;
    --img-height: 80vw;
    object-fit: cover;
  }

  @media (min-width: 600px) {
    display: none;
  }
`;

const DesktopOnlyContainer = styled.div`
  display: none;

  @media (min-width: 600px) {
    display: block;
    width: 100vw;
    height: 20vw;

    /* stylelint-disable-next-line selector-type-no-unknown */
    && progressive-img, img {
      width: 100vw;
      height: 20vw;
      --img-width: 100vw;
      --img-height: 20vw;
      object-fit: cover;
    }
  }
`;

const JobsMobileOnlyContainer = styled.div`
  width: 100vw;
  height: 80vw;

  /* stylelint-disable-next-line selector-type-no-unknown */
  && progressive-img, img {
    width: 100vw;
    height: 80vw;
    --img-width: 100vw;
    --img-height: 80vw;
    object-fit: cover;
  }

  @media (min-width: 600px) {
    display: none;
  }
`;

const JobsDesktopOnlyContainer = styled.div`
  display: none;
  width: 100vw;
  height: 20vw;

  @media (min-width: 600px) {
    display: block;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  && progressive-img, img {
    width: 100vw;
    height: 20vw;
    --img-width: 100vw;
    --img-height: 20vw;
    object-fit: cover;
  }
`;

export {
  DesktopOnlyContainer,
  MobileOnlyContainer,
  JobsMobileOnlyContainer,
  JobsDesktopOnlyContainer,
  SplitHeroMobileContainer,
  SplitHeroDesktopContainer,
};
